import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { blankTable, MAX_COLS } from "./gridModel";

export default function AddTableDialog({ open, onOpenChange, onCreate }) {
  const [cols, setCols] = useState(10);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="add-table-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Add ITP Table</DialogTitle>
          <DialogDescription>How many columns?</DialogDescription>
        </DialogHeader>
        <div className="flex items-end gap-2">
          <div>
            <Label>Columns (1–{MAX_COLS})</Label>
            <Input type="number" min="1" max={MAX_COLS} value={cols} className="mt-1 h-9 w-24"
              onChange={(e) => setCols(Math.max(1, Math.min(MAX_COLS, parseInt(e.target.value, 10) || 1)))}
              data-testid="add-table-cols-input"/>
          </div>
          <Button className="bg-teal-700 hover:bg-teal-800" onClick={() => onCreate(blankTable(cols))} data-testid="add-table-create-btn">
            Create table
          </Button>
        </div>
        <p className="text-[11px] text-slate-400">You can add, rename, resize and remove columns at any time afterwards.</p>
      </DialogContent>
    </Dialog>
  );
}
